"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentUserCanDelete = exports.currentUserCanUpdate = exports.currentUserCanRead = exports.currentUserCanCreate = exports.currentUserCanDo = exports.currentUserCanAdmin = exports.currentUserCan = exports.personCanReadHomeSection = exports.personCanUpdate = exports.personCanDelete = exports.personCanCreate = exports.personCanDo = exports.personCanAdmin = exports.personCanList = exports.personCanRead = exports.personCanAdminOr = exports.personCan = void 0;
var lodash_1 = require("lodash");
var to_array_1 = require("./to-array");
var use_active_person_1 = require("../hooks/use-active-person");
var use_entity_definition_named_1 = require("../hooks/use-entity-definition-named");
var env_1 = require("../env");
// --- New hookless methods to allow performance-optimization through memoized calls
var personCan = function (personResult, permissions) {
  if (permissions === void 0) {
    permissions = [];
  }
  var currentPermissions = personResult.permissions.map(function (_a) {
    var id = _a.id;
    return id;
  });
  return (0, lodash_1.intersection)((0, to_array_1.toArray)(permissions), currentPermissions).length !== 0;
};
exports.personCan = personCan;
var personCanAdminOr = function (personResult, permissions) {
  if (permissions === void 0) {
    permissions = [];
  }
  return (0, exports.personCanAdmin)(personResult) || (0, exports.personCan)(personResult, permissions);
};
exports.personCanAdminOr = personCanAdminOr;
var personCanRead = function (personResult, entityScopeSlug, isEntityPublic) {
  var scopes = ['write:any', 'read:any', "write:".concat(entityScopeSlug), "read:".concat(entityScopeSlug)];
  if (isEntityPublic) {
    scopes.push('read:public');
  }
  return (0, exports.personCan)(personResult, scopes);
};
exports.personCanRead = personCanRead;
var personCanList = function (personResult, entityScopeSlug, isEntityPublic) {
  var scopes = ['write:any', 'read:any', "list:".concat(entityScopeSlug), "read:".concat(entityScopeSlug)];
  return (0, exports.personCan)(personResult, scopes);
};
exports.personCanList = personCanList;
var personCanAdmin = function (personResult, entityScopeSlug) {
  return (0, exports.personCan)(personResult, ['admin:any', "admin:".concat(entityScopeSlug)]);
};
exports.personCanAdmin = personCanAdmin;
var personCanDo = function (personResult, entityScopeSlug, action, extras) {
  if (extras === void 0) {
    extras = [];
  }
  return (0, exports.personCan)(personResult, __spreadArray(['write:any', "write:".concat(entityScopeSlug), "".concat(action, ":").concat(entityScopeSlug)], __read(extras), false));
};
exports.personCanDo = personCanDo;
var personCanCreate = function (personResult, entityScopeSlug) {
  return (0, exports.personCanDo)(personResult, entityScopeSlug, 'create');
};
exports.personCanCreate = personCanCreate;
var personCanDelete = function (personResult, entityScopeSlug) {
  return (0, exports.personCanDo)(personResult, entityScopeSlug, 'delete');
};
exports.personCanDelete = personCanDelete;
var personCanUpdate = function (personResult, entityScopeSlug) {
  return (0, exports.personCanDo)(personResult, entityScopeSlug, 'update');
};
exports.personCanUpdate = personCanUpdate;
var personCanReadHomeSection = function (personResult, section) {
  return env_1.USE_GRANULAR_HOME_SCOPES ? (0, exports.personCanAdminOr)(personResult, "read:".concat(section)) : true;
};
exports.personCanReadHomeSection = personCanReadHomeSection;
// --- Maintain existing currentUserCan methods, which will call the necessary hooks
// --- NB: These cannot be used inside useMemo hook functions!
var currentUserCan = function (permissions) {
  if (permissions === void 0) {
    permissions = [];
  }
  return (0, exports.personCan)((0, use_active_person_1.useActivePerson)(), permissions);
};
exports.currentUserCan = currentUserCan;
var currentUserCanAdmin = function (entityTypeName) {
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var user = (0, use_active_person_1.useActivePerson)();
  if (definition) {
    return (0, exports.personCanAdmin)(user, definition.scopeSlug);
  }
  return (0, exports.personCanAdmin)(user);
};
exports.currentUserCanAdmin = currentUserCanAdmin;
var currentUserCanDo = function (entityTypeName, action, extras) {
  if (extras === void 0) {
    extras = [];
  }
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var user = (0, use_active_person_1.useActivePerson)();
  if (definition) {
    return (0, exports.personCanDo)(user, definition.scopeSlug, action, extras);
  }
};
exports.currentUserCanDo = currentUserCanDo;
var currentUserCanCreate = function (entityTypeName) {
  return (0, exports.currentUserCanDo)(entityTypeName, 'create');
};
exports.currentUserCanCreate = currentUserCanCreate;
var currentUserCanRead = function (entityTypeName) {
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var user = (0, use_active_person_1.useActivePerson)();
  if (definition) {
    return (0, exports.personCanRead)(user, definition.scopeSlug, definition.isPublic);
  }
};
exports.currentUserCanRead = currentUserCanRead;
var currentUserCanUpdate = function (entityTypeName) {
  return (0, exports.currentUserCanDo)(entityTypeName, 'update');
};
exports.currentUserCanUpdate = currentUserCanUpdate;
var currentUserCanDelete = function (entityTypeName) {
  return (0, exports.currentUserCanDo)(entityTypeName, 'delete');
};
exports.currentUserCanDelete = currentUserCanDelete;